import axios from 'axios'

export interface ExportParams {
  name: string
  sheets: Sheet[]
}

export interface Sheet {
  name: string
  data: unknown[]
}

export const exportExcel = async ({
  name,
  sheets,
}: ExportParams): Promise<void> => {
  const filename = `${name}.xlsx`
  const token = localStorage.getItem('traind:token')
  try {
    const resp = await axios({
      url: 'https://alpha.traind.se/v3/file/xlsx',
      method: 'POST',
      responseType: 'arraybuffer',
      headers: {
        Authorization: 'Bearer ' + token,
      },
      data: {
        name,
        sheets,
      },
    })

    const a = document.createElement('a')
    const url = window.URL.createObjectURL(
      new Blob([resp.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
    )
    a.href = url
    a.target = '_blank'
    a.download = filename
    document.body.appendChild(a)
    a.click()
  } catch (err) {
    console.dir(err)
  }
}
